export default "__VITE_ASSET__D5hLsNhd__"